import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const Navbar = () => {

    const handleScroll = () => {
        if (window.scrollY > 20) {
            document.querySelector(".navbar").className = "navbar scroll"
        } else {
            document.querySelector(".navbar").className = "navbar";
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    })

    return (
        <Nav className="navbar">
            <Container>
                <Link to="/">
                    <img src="/images/logo.png" alt="Logo" />
                    <h1>#100DaysOfCode</h1>
                </Link>
            </Container>
            <Container>
                <Link to="/projects">
                    <h1>Projects <i className="fas fa-shapes"></i> </h1>
                </Link>
                <span>|</span>
                <h1><i className="fas fa-bars"></i></h1>
            </Container>
        </Nav>
    )
}

const Nav = styled.nav``;

const Container = styled.div`
    color: #fff;
    display: flex;
    align-items: center;

    & > a {
    text-decoration: none;
    display: flex;
    align-items: center;
    }

    & > a > h1 {
        margin: 0 1rem;
        font-size: 1.7rem;
        line-height: 2.8rem;
        color: #fff;
    }

    & > h1 {
        margin: 0 1rem;
        font-size: 1.7rem;
        line-height: 2.8rem;
    }
`;

export default Navbar
